import { render } from "./Item.vue?vue&type=template&id=4e0a859a&scoped=true&ts=true"
import script from "./Item.vue?vue&type=script&lang=ts"
export * from "./Item.vue?vue&type=script&lang=ts"

import "./Item.vue?vue&type=style&index=0&id=4e0a859a&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0a859a"]])

export default __exports__